"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SOURCES = void 0;
var dutchiePaySources = {
    AGGREGATOR: 'aggregator',
    CONSUMER_VELOCITY_CHECK: 'dutchie-pay-consumer-velocity-check',
    DUTCHIE_PAY: 'dutchie-pay',
    MX: 'mx',
    PLAID: 'plaid',
    SARDINE: 'sardine',
    SIFT: 'sift',
    TRANSACTION_VELOCITY_CHECK: 'dutchie-pay-transaction-velocity-check',
};
var cardSources = {
    PAYMENTS: 'payments',
    REGALA: 'regala',
};
var pinDebitSources = {
    DATA_CAP: 'Data Cap/LLX',
    DC_DIRECT: 'DC Direct',
    PAYNETWORX: 'Paynetworx',
    TRANCLOUD: 'Trancloud',
};
exports.SOURCES = __assign(__assign(__assign({}, cardSources), dutchiePaySources), pinDebitSources);
